import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { ComplementaryReportFilesActions } from '../actions/complementary-report-files.actions';
import { FileMetadataDto } from 'projects/aumico-project-reports/src/app/microservices/ms-annual-reports/financial-closing-process/dto/file-metadata.dto';

export const COMPLEMENTARY_REPORT_FILES_FEATURE_KEY = 'complementary-report-files-key';
export interface ComplementaryReportFilesState extends EntityState<FileMetadataDto> {
    loading: boolean;
    error: any;
}

export const adapter: EntityAdapter<FileMetadataDto> = createEntityAdapter<FileMetadataDto>({
    selectId: (document) => document.uuid,
});

export const initialState: ComplementaryReportFilesState = adapter.getInitialState({
    loading: false,
    error: null,
});

// Feature
export const selectComplementaryReportFilesState = createFeatureSelector<ComplementaryReportFilesState>(COMPLEMENTARY_REPORT_FILES_FEATURE_KEY);

const { selectEntities } = adapter.getSelectors();

export const selectComplementaryReportFilesEntities = createSelector(selectComplementaryReportFilesState, selectEntities);

export const selectComplementaryReportFileById = (id: string) => createSelector(selectComplementaryReportFilesEntities, (entities) => entities[id]);

const complementaryReportFilesReducerInternal = createReducer(
    initialState,

    // Upload Complementary Report File
    on(ComplementaryReportFilesActions.uploadComplementaryReportFile, (state) => ({ ...state, loading: true })),
    on(ComplementaryReportFilesActions.uploadComplementaryReportFileSuccess, (state, { document }) =>
        adapter.addOne(document, {
            ...state,
            loading: false,
        }),
    ),
    on(ComplementaryReportFilesActions.uploadComplementaryReportFileFailure, (state, { error }) => ({ ...state, loading: false, error })),
);

export function complementaryReportFilesReducer(state: ComplementaryReportFilesState | undefined, action: Action) {
    return complementaryReportFilesReducerInternal(state, action);
}
